import * as S from './Table.styles'

export const Table = ({ testId = 'table-id', children }: any) => {
  return <S.Table data-testid={testId}>{children}</S.Table>
}
